const PAGINATION = {
  PREV_PAGE: '← ANTERIOR',
  NEXT_PAGE: '→ SIGUIENTE'
};

export default PAGINATION;
